import { InternalAxiosRequestConfig } from "axios";

export const authMiddleware = (config: InternalAxiosRequestConfig) => {
  if (typeof window !== "undefined") {
    const raw = localStorage.getItem("token") ?? "";
    const token = raw.replace(/^Bearer\s+/i, "");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
};
